import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isImpersonating, isAdmin } from './../../jsCore/store/currentUser/currentUser.selectors'

class RestrictedAreaComponent extends Component {
  isAllowed = () => isAdmin(this.props) || isImpersonating(this.props)

  render = () => (this.isAllowed() ? this.props.children : null)
}

RestrictedAreaComponent.propTypes = {
  children: PropTypes.element.isRequired,
}

const mapStateToProps = state => state.currentUser

export const RestrictedArea = connect(mapStateToProps)(RestrictedAreaComponent)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/admin_panel/RestrictedArea.container.js